import * as React from "react";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from "@mui/x-date-pickers";
import { StaticDatePicker } from '@mui/x-date-pickers'
import { PickersDay } from '@mui/x-date-pickers/PickersDay'
import startOfDay from "date-fns/startOfDay";
import { alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { IoIosArrowDown } from "react-icons/io";
import { Chip } from "@mui/material";

const CustomPickersDay = styled(PickersDay, {
    shouldForwardProp: (prop) => prop !== "selected"
})(({ theme, selected }) => ({
    ...(selected && {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        "&:hover, &:focus": {
            backgroundColor: theme.palette.primary.dark
        },
        borderTopLeftRadius: "50%",
        borderBottomLeftRadius: "50%",
        borderTopRightRadius: "50%",
        borderBottomRightRadius: "50%"
    })
}));
const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color:
            theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
    },
}));

export default function DatePickerMulti(props) {

    const { values, setValues } = props

    const [anchorEl, setAnchorEl] = React.useState(null)
    const open = Boolean(anchorEl)

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const findDate = (dates, date) => {
        const dateTime = date.getTime()
        return dates.find((item) => item.getTime() === dateTime);
    }

    const findIndexDate = (dates, date) => {
        const dateTime = date.getTime();
        return dates.findIndex((item) => item.getTime() === dateTime);
    }

    const renderPickerDay = (date, selectedDates, pickersDayProps) => {
        if (!values) {
            return <PickersDay {...pickersDayProps} />;
        }
        const selected = findDate(values, date);
        return (
            <CustomPickersDay
                {...pickersDayProps}
                disableMargin
                selected={selected}
            />
        )
    }

    const handleDateChange = (newValue) => {
        const array = [...values]
        const date = startOfDay(newValue)
        const index = findIndexDate(array, date)
        if (index >= 0) {
            array.splice(index, 1)
        } else {
            array.push(date)
        }
        setValues(array)
    }

    const handleSelectAllMonth = () => {
        setValues([])

        // Seleciona todos los dias del mes
        const date = new Date()
        const daysInMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()
        const array = []
        for (let i = 1; i <= daysInMonth; i++) {
            array.push(new Date(date.getFullYear(), date.getMonth(), i))
        }
        setValues(array)

    }
    return (
        <>
            <div
                style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    background: 'none',
                    borderRadius: '0',
                    padding: '0',
                    boxShadow: 'none',
                    marginBottom: '5px'
                }}
            >
                <span
                    style={{
                        fontWeight: '500',
                        color: '#444',
                        fontSize: '15px',
                        marginRight: '8px',
                        letterSpacing: '0.2px'
                    }}
                >
                    Fechas seleccionadas {values.length > 0 ? `(${values.length})` : ''}
                </span>
                <button
                    type="button"
                    onClick={handleSelectAllMonth}
                    style={{
                        flex: 1,
                        background: 'none',
                        color: '#1976d2',
                        border: '1px solid #e0e0e0',
                        borderRadius: '3px',
                        padding: '9px 10px',
                        cursor: 'pointer',
                        fontSize: '13px',
                        fontWeight: '400',
                        minWidth: '120px'
                    }}
                >
                    Mes actual
                </button>
                <button
                    type="button"
                    onClick={handleClick}
                    style={{
                        flex: 1,
                        background: 'none',
                        color: '#43a047',
                        border: '1px solid #e0e0e0',
                        borderRadius: '3px',
                        padding: '9px 10px',
                        cursor: 'pointer',
                        fontSize: '13px',
                        fontWeight: '400',
                        minWidth: '120px'
                    }}
                >
                    Seleccionar fechas
                </button>
            </div>
            <div
                style={{
                    width: '100%',
                    backgroundColor: '#fff',
                    border: '0px solid #e0e0e0',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                }}
                onClick={handleClick}
            >
                <div style={{
                    overflowY: 'auto',
                    maxHeight: 220,
                    width: '100%',
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '6px',
                    background: '#fff',
                    borderRadius: '6px',
                    padding: '8px 4px'
                }}>
                    <span style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                        {values.map((item, index) => {
                            return (
                                <Chip
                                    key={index}
                                    label={item.toLocaleDateString('es-ES')}
                                    variant="outlined"
                                    style={{
                                        backgroundColor: '#f5f5f5',
                                        color: '#333',
                                        margin: 0,
                                        fontSize: 12,
                                        borderRadius: '4px',
                                        padding: '0 8px',
                                        height: '28px',
                                        minWidth: '110px',
                                        maxWidth: '110px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        textAlign: 'center',
                                        boxSizing: 'border-box',
                                        cursor: 'pointer'
                                    }}
                                />
                            )
                        })}
                    </span>
                </div>
            </div>
            <StyledMenu
                id="demo-customized-menu"
                MenuListProps={{
                    'aria-labelledby': 'demo-customized-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <StaticDatePicker
                        displayStaticWrapperAs="desktop"
                        label="Week picker"
                        value={values}
                        onChange={(newValue) => {
                            handleDateChange(newValue)
                        }}
                        renderDay={renderPickerDay}
                        renderInput={(params) => <TextField {...params} />}
                        inputFormat="'Week of' MMM d"
                    />
                </LocalizationProvider>
            </StyledMenu>
        </>
    );
}